import { EReportGroupBy, EReportTypes, IMetric, TReportList } from 'entities/Report';
import { commonApi } from 'shared/api/commonApi';

export const reportApi = commonApi.injectEndpoints({
	endpoints: (builder) => ({
		getReportsList: builder.query<TReportList, { type: EReportTypes; groupBy: EReportGroupBy; params: string }>({
			query: ({ params, type, groupBy }) => ({
				url: `reports/${type}/${type === EReportTypes.DATE ? groupBy + '/' : ''}${params ? '?' : ''}${params}`,
			}),
		}),

		getReportsChart: builder.query<IMetric[], string>({
			query: (params) => ({
				url: `reports/metrics/${params ? '?' : ''}${params}`,
			}),
		}),

		exportReport: builder.mutation<null, { type: EReportTypes; groupBy: EReportGroupBy; params: string }>({
			queryFn: async ({ params, type, groupBy }, _, __, baseQuery) => {
				const result = await baseQuery({
					url: `reports/${type}/${type === EReportTypes.DATE ? groupBy + '/' : ''}export/${params ? '?' : ''}${params}`,
					responseHandler: async (response) => {
						return response.status === 200 ? response.blob() : response.json();
					},
				});

				if (result.meta?.response?.status === 200) {
					const hiddenLink = document.createElement('a');
					const currentUrl = window.URL || window.webkitURL;
					const fileBlob = currentUrl.createObjectURL(result.data as Blob);
					hiddenLink.href = fileBlob;
					hiddenLink.target = '_blank';
					hiddenLink.download = `${type}_${type === EReportTypes.DATE ? groupBy + '_' : ''}report_${new Date().toISOString().split('T').join('_').split(':').join('-').split('.').join('-').split('Z').join('')}.xlsx`;
					hiddenLink.click();
				}
				return { data: null };
			},
		}),
	}),
});

export const { useGetReportsListQuery, useGetReportsChartQuery, useExportReportMutation } = reportApi;
